import { Box } from "@mui/material";

import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";
import { STATUS, statusMetaForLoan } from "./closingCalendarUtils";

// Small colour dot keyed to a readiness level.
export const StatusDot = ({ statusKey, size = 8 }) => {
  const s = STATUS[statusKey] || STATUS.not_scheduled;
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "99px",
        background: s.c,
        flexShrink: 0,
      }}
    />
  );
};

// Pill badge: dot + label, tinted by readiness level. Pass either the level
// key or the card itself.
export const StatusBadge = ({ statusKey, loan }) => {
  const s = STATUS[statusKey] || statusMetaForLoan(loan) || STATUS.not_scheduled;
  return (
    <Flx
      ac
      g={0.6}
      sx={{
        px: 1,
        py: 0.4,
        borderRadius: "99px",
        background: s.bg,
        color: s.c,
        flexShrink: 0,
      }}
    >
      <StatusDot statusKey={s.key} size={7} />
      <Txt sx={{ fontSize: 11.5, fontWeight: 700, color: s.c, whiteSpace: "nowrap" }}>
        {s.label}
      </Txt>
    </Flx>
  );
};
